// removed by extract-text-webpack-plugin
module.exports = {"item":"_3uccF_6U9Gm8JCbcl2zZA","image":"_30gCkxz6kXLiIdrPSMNYAB","info":"_3imyb9yUto2PsOj-49kIBg","buttons":"_1RoF9GI_GH-Gi8UbidDgDW","name":"_3aZw8ieLNm8TbZlNx7Zof1","description":"iUHrE3rIo-QUKpjJbDneU","text":"_1FuxjBV0_JD8lXYt4fOuq-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryItem/GalleryItem.module.scss
// module id = 769
// module chunks = 0